export default "__VITE_ASSET__C88X36cp__"